import styled from "styled-components";
import { ActionComponent } from "../../shared/utils/userProfile";

export const AvatarImg = styled.img`
  width: ${(props) => (props.$isProfileMenuAvatarImg ? "100%" : "180px")};
  height: ${(props) => (props.$isProfileMenuAvatarImg ? "100%" : "180px")};
  border-radius: 50%;
`;

export const AvatarDisplayName = styled.div(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.colours.scheduleBg};
  font: ${theme.typography.primaryFont};

  & span {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    overflow: hidden;
    -webkit-box-orient: vertical;
    padding: 0 14px;
  }
`
);

export const ProfileButton = styled(ActionComponent)(
  ({ theme }) => `
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  background: transparent;
  text-align: center;
  border: 0;
  padding: 0;
  cursor: pointer;
  width: ${theme.sizes.avatarSize};
  transition: transform 0.2s;
  position: relative;
  color: ${theme.colours.white};

  &:hover {
    transform: ${theme.scales.hoverEmphasis};

    ${AvatarImg}, ${AvatarDisplayName}::after {
      border: 4px solid ${theme.colours.white};
      padding: 4px;
      margin: -8px;
    }

    ${AvatarDisplayName}::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  ${AvatarDisplayName},
  ${AvatarDisplayName}::after {
    width: ${theme.sizes.avatarSize};
    height: ${theme.sizes.avatarSize};
    border-radius: 50%;
  }
`
);

export const ProfileEditImg = styled.img(
  ({ theme }) => `
  position: absolute;
  top: calc(${theme.sizes.avatarSize} - 60px);
  right: 0;
  width: 60px;
  height: 60px
`
);

export const AvatarTitle = styled.span`
  margin-top: 16px;
  font: ${({ theme }) => theme.typography.primaryFont};
`;

export const AvatarSubTitle = styled.span(
  ({ theme }) => `
  margin-top: 9px;
  font: ${theme.typography.regularFont};
  font-size: ${theme.typography.largeFontSize};
  color: ${theme.colours.gray};
`
);
export const KidsLabelImg = styled.img`
  margin-top: 12px;
  height: 24px;
`;
